// Browse Talent Filter (Actors)
// 

JLM.MD.TalentBrowseFilterActors = function( container, data_all ) {
	
	const INSTANCE = new JLM.MD.TalentBrowseFilter( container, data_all );
	
	
	// Constants: Private _______________________________________________________
	
	const AGE_RANGES = {
		'Y': [5, 10, 12, 14, 16],
		'A': [16, 18, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 80]
	};
	
	
	
	// Variables: Private _______________________________________________________
	
	// Data
	let data_locations, data_ethnicities;
	
	// References
	let header_title;
	
	// Settings
	let timeout_typing;
	
	
	
	// Variables: Public ________________________________________________________
	
	// References
	INSTANCE.f_age_group = null;
	INSTANCE.f_age = null;
	INSTANCE.f_location = null;
	INSTANCE.f_ethnicity = null;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// Data
		data_locations = getLocationData();
		data_ethnicities = getEthnicityData();
		
		// References
		header_title = $('.filter h1', container);
		
		// Fields
		INSTANCE.f_age_group = new JLM.MD.Radiogroup( $('#f_filter_age_group', container) );
		INSTANCE.f_age = new JLM.MD.DropdownRange( $('#f_filter_age', container) );
		INSTANCE.f_location = new JLM.MD.DropdownList( $('#f_filter_location', container), data_locations );
		INSTANCE.f_ethnicity = new JLM.MD.DropdownTags( $('#f_filter_ethnicity', container), data_ethnicities );
		
		// Events
		INSTANCE.f_age_group.on('change', onChangeAgeGroup);
		INSTANCE.f_age.on('change', INSTANCE.onChange);
		INSTANCE.f_location.on('change', INSTANCE.onChange);
		INSTANCE.f_ethnicity.on('change', INSTANCE.onChange);
		INSTANCE.on('sup_change', INSTANCE.onChange);
		
		// Set data
		INSTANCE.filter();
	}
	
	
	
	// Methods: Data Retrieval __________________________________________________
	
	// Update the age range, based on group
	// 
	function onChangeAgeGroup( group_value ) {
		header_title.html( group_value == 'Y' ? 'Youth Actors' : 'Actors' );
		container.attr('data-age-group', group_value)
		INSTANCE.f_age.set( AGE_RANGES[ group_value ] );
		INSTANCE.onChange();
	}
	
	
	// Data: Locations
	// 
	function getLocationData() {
		// Data
		const data_countries = JLM.database.getCountries(),
			  data_locations = JLM.database.getLocations();
		
		// Structured data for dropdown
		let data_dd_location = [{ label: 'All Locations', value: '', selected: true }];
		
		// For each country
		for( let country_code in data_locations ) {
			// Country entry
			let location_country = {
				label: data_countries[ country_code ].Name,
				value: country_code
			};
			location_country.sub = [];
			
			// For each city
			data_locations[ country_code ].forEach(function( city ) {
				// City entry
				location_country.sub.push({
					label: city,
					value: country_code + '/' + city
				});
			});
			
			// Add to list
			data_dd_location.push( location_country );
		}
		
		return data_dd_location;
	}
	
	
	// Data: Ethnicity
	// 
	function getEthnicityData() {
		// Data
		const data_ethnicities = JLM.database.getEthnicities();
		
		// Structured data for dropdown
		let data_dd_ethnicities = [];
		
		// For each ethnicity entry
		data_ethnicities.forEach(function( data_ethnicity ) {
			data_dd_ethnicities.push({ label: data_ethnicity.Ethnicity, value: data_ethnicity.ID });
		});
		
		return data_dd_ethnicities;
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// When form changes
	// 
	INSTANCE.onChange = function() {
		// Settings
		let crumbs = [],
			data_filter = {};
		
		// Store filter params
		if ( INSTANCE.f_name.value ) {
			crumbs.push('Name: ' + INSTANCE.f_name.value);
			data_filter.name = INSTANCE.f_name.value;
		}
		if ( INSTANCE.f_gender.value ) {
			crumbs.push( INSTANCE.f_gender.value == 'M' ? 'Male' : 'Female' );
			data_filter.gender = INSTANCE.f_gender.value;
		}
		data_filter.age_group = INSTANCE.f_age_group.value;
		let age_range = INSTANCE.f_age.value[0] + '-' + INSTANCE.f_age.value[1];
		if ( INSTANCE.f_age.value[0] == INSTANCE.f_age.value[1] ) age_range = INSTANCE.f_age.value[0];
			crumbs.push( age_range );
			data_filter.age = age_range;
		if ( INSTANCE.f_location.value ) {
			let location = JLM.MD.TalentBrowseFilter.getLocationValues( INSTANCE.f_location.value ),
				country_label = JLM.MD.TalentBrowseFilter.getDataLabel( data_locations, location.country ),
				location_full = ( location.city ? location.city + ', ' : '' ) + country_label;
			crumbs.push( location_full );
			data_filter.location = location_full;
		}
		if ( INSTANCE.f_ethnicity.value.length ) {
			let ethnicities = [];
			INSTANCE.f_ethnicity.value.forEach(function( ethnicity_value ) {
				let ethnicity_label = JLM.MD.TalentBrowseFilter.getDataLabel( data_ethnicities, ethnicity_value );
				crumbs.push( ethnicity_label );
				ethnicities.push( ethnicity_label );
			});
			data_filter.ethnicities = ethnicities.join(', ');
		}
		
		// Update breadcrumbs
		INSTANCE.updateHeaderCrumbs( crumbs );
		
		// Update results
		INSTANCE.filter();
		
		// Track
		if ( timeout_typing ) clearTimeout( timeout_typing );
		timeout_typing = setTimeout(function() {
			let url_params = JLM.MT.paramsToQueryString( data_filter );
			JLM.MT.trackPageview( window.location.pathname + '?' + url_params );
			timeout_typing = null;
		}, 750);
		
		// Announce change
		INSTANCE.dispatchEvent('change', [ INSTANCE.matches, INSTANCE.f_name.value ]);
	};
	
	
	// Filter dataset
	// 
	INSTANCE.filter = function() {
		// Location value
		let location = JLM.MD.TalentBrowseFilter.getLocationValues( INSTANCE.f_location.value );
		
		// Reset matches
		INSTANCE.matches = {};
		
		// Filter talent data
		data_all.forEach(function( talent ) {
			let is_match = true;
			
			// Name
			if ( is_match && INSTANCE.f_name.value ) {
				let name = talent.Firstname + ' ' + talent.Lastname,
					regex = new RegExp("\\b(" + INSTANCE.f_name.value + ')', "i");
				if ( !name.match( regex ) ) {
					is_match = false;
				}
			}
			
			// Gender
			if ( is_match && INSTANCE.f_gender.value ) {
				if ( talent.Gender !== INSTANCE.f_gender.value ) {
					is_match = false;
				}
			}
			
			// Age group
			if ( is_match ) {
				if ( talent.AgeGroup !== INSTANCE.f_age_group.value ) {
					is_match = false;
				}
			}
			
			// Age
			if ( is_match ) {
				if ( !INSTANCE.f_age.isLimits() && ( talent.Range[0] > INSTANCE.f_age.value[1] || talent.Range[1] < INSTANCE.f_age.value[0] ) ) {
					is_match = false;
				}
			}
			
			// Location
			if ( is_match && INSTANCE.f_location.value ) {
				if ( location.country ) {
					if ( talent.CountryCode !== location.country ) {
						is_match = false;
					} else if ( location.city ) {
						if ( talent.City !== location.city ) {
							is_match = false;
						}
					}
				}
			}
			
			// Ethnicity
			if ( is_match && INSTANCE.f_ethnicity.value.length ) {
				if ( !talent.Ethnicities || talent.Ethnicities.length == 0 ) {
					is_match = false;
				} else {
					let match_ethnicity = false,
						i = talent.Ethnicities.length;
					while(i--) {
						if ( INSTANCE.f_ethnicity.value.indexOf( talent.Ethnicities[i] ) >= 0 ) {
							match_ethnicity = true;
							break;
						}
					}
					if ( !match_ethnicity ) {
						is_match = false;
					}
				}
			}
			
			// Add to list of matches
			if ( is_match ) INSTANCE.matches[ talent.ID ] = 1;
		});
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};